import { active_tab_button, SERVICE_LIST, tab_button } from '../../../../../functions/stateList'
import React, { useEffect, useState } from 'react'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import ServiceItemContent from './ServiceItemContent'

function NewService() {
  const [activeId, setActiveId] = useState(1)
  const [activeFilter, setActiveFilter] = useState('خدمات تعویض روغن')
  const [productWithType, setProductWithType] = useState({})
  const [types, setTypes] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      const apiResult = await getData(
        'admin/site-options/products',
        'get',
        { filter: activeFilter },
        true
      )
      if (apiResult) {
        if (apiResult.status === 200) {
          let productsList = apiResult?.data?.products
          let products_types = apiResult?.data?.products_types

          let queryParams = {}
          for (let type of products_types) {
            queryParams[type] = productsList.filter((info) => info?.product === type)
          }
          setProductWithType(queryParams)
          setTypes(products_types)
        }
        setLoading(false)
      }
    }

    fetchData()
  }, [activeFilter])

  const showServiceHandler = (id) => {
    setActiveId(id)
    if (id === 1) {
      setActiveFilter('خدمات تعویض روغن')
    } else if (id === 2) {
      setActiveFilter('خدمات مکانیکی')
    } else if (id === 3) {
      setActiveFilter('خدمات لاستیک')
    } else if (id === 4) {
      setActiveFilter('خدمات نظافتی')
    }
  }

  return (
    <div
      className={
        'bg-light-blue dark:bg-slate-800 dark:border-gray-700 border border-light-gray rounded-lg my-6 py-6 md:py-8 px-6 md:px-16'
      }
    >
      <h1 className={'text-center text-2xl font-medium mb-4 dark:text-amber-50'}>خدمات اجرایی</h1>
      <p className={'text-center text-lg font-normal mb-16 dark:text-slate-200'}>
        خدمات انجام شده را پر کنید
      </p>

      <div className="flex flex-wrap items-center mb-8">
        {SERVICE_LIST.length > 0 &&
          SERVICE_LIST.map(({ id, title }) => (
            <button
              className={activeId === id ? active_tab_button : tab_button}
              key={id}
              onClick={() => showServiceHandler(id)}
            >
              {title}
            </button>
          ))}
      </div>

      <ServiceItemContent
        isLoading={isLoading}
        activeFilter={activeFilter}
        types={types}
        activeId={activeId}
        productWithType={productWithType}
      />
    </div>
  )
}

export default React.memo(NewService)
